<p>case-detail-section works!</p>
